import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FallingLines } from 'react-loader-spinner';
// same card layout as the verify page
import '../Verify/css/Verify.css';
import { resetPassword } from '../../Utils/RestUtils';
import { changeLoginModalVisibility } from '../../DataStore/actions/modalWindowActions';
import {
  SAVE,
  ENTER,
  SYSTEM_FAULT,
  VERIFY_PASSWORD_HINT,
  VERIFY_SHOW_PASSWORD,
  VERIFY_HIDE_PASSWORD,
  TO_MAIN_PAGE,
  RESET_PASSWORD_TITLE,
  RESET_PASSWORD_TEXT,
  RESET_PASSWORD_LABEL,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_SUCCESS_TEXT,
  RESET_PASSWORD_ERROR_TITLE,
  RESET_PASSWORD_ERROR_TEXT,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as Success } from '../../images/success-r.svg';

const FORM_STAGE = 'form';
const SUCCESS_STAGE = 'success';
const ERROR_STAGE = 'error';

const mapStateToProps = (state) => ({ ...state });

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    const { location } = props;
    const queryParameters = new URLSearchParams(location.search);
    const email = queryParameters.get('email') || '';
    const code = queryParameters.get('code') || '';

    this.state = {
      stage: email && code ? FORM_STAGE : ERROR_STAGE,
      email,
      code,
      passwordValue: '',
      isPasswordValid: false,
      isPasswordVisible: false,
      isSubmitSpinnerVisible: false,
      errorMessage: '',
    };
  }

  handlePasswordChange = (e) => {
    const passwordValue = e.target.value;
    this.setState({
      passwordValue,
      isPasswordValid: passwordValue.length >= 8,
      errorMessage: '',
    });
  };

  handlePasswordVisibilityClick = () => {
    const { isPasswordVisible } = this.state;
    this.setState({ isPasswordVisible: !isPasswordVisible });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {
      passwordValue,
      email,
      code,
      isPasswordValid,
      isSubmitSpinnerVisible,
    } = this.state;

    if (!isPasswordValid || isSubmitSpinnerVisible) {
      return;
    }

    this.setState({ isSubmitSpinnerVisible: true, errorMessage: '' });

    const payload = {
      password: passwordValue,
      email,
      code,
    };

    resetPassword(payload)
      .then((response) => {
        // empty response means the code is wrong or expired
        this.setState({
          stage:
            response && response.data === 'success'
              ? SUCCESS_STAGE
              : ERROR_STAGE,
        });
      })
      .catch(() => {
        this.setState({ errorMessage: SYSTEM_FAULT });
      })
      .finally(() => {
        this.setState({ isSubmitSpinnerVisible: false });
      });
  };

  handleLoginClick = () => {
    const { changeLoginModalVisibility: changeLoginModalVisibilityAction } =
      this.props;
    changeLoginModalVisibilityAction(true);
  };

  getHintClass = () => {
    const { isPasswordValid } = this.state;
    return `v_hint ${isPasswordValid ? 'greenr_text_14' : 'gr_text_14'}`;
  };

  getSubmitClass = () => {
    const { isPasswordValid } = this.state;
    return `v_button wm_text_16 ${
      isPasswordValid ? 'blue_button' : 'v_button_dis'
    }`;
  };

  renderForm = () => {
    const {
      email,
      passwordValue,
      isPasswordValid,
      isPasswordVisible,
      isSubmitSpinnerVisible,
      errorMessage,
    } = this.state;

    return (
      <form className="v_card" onSubmit={this.handleSubmit}>
        <div className="bm_text_24 mb_12">{RESET_PASSWORD_TITLE}</div>
        <div className="gr_text_16 mb_8">{RESET_PASSWORD_TEXT}</div>
        <div className="bm_text_16 v_email mb_30">{email}</div>

        {/* lets password managers bind the new password to the email */}
        <input
          type="email"
          value={email}
          autoComplete="username"
          readOnly
          hidden
        />

        <label className="gr_text_14 mb_8" htmlFor="rp_password">
          {RESET_PASSWORD_LABEL}
        </label>
        <div className="v_input_w">
          <input
            id="rp_password"
            value={passwordValue}
            className="v_input"
            onChange={this.handlePasswordChange}
            type={isPasswordVisible ? 'text' : 'password'}
            autoComplete="new-password"
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
          />
          <button
            type="button"
            className="v_input_toggle bluem_text_14"
            onClick={this.handlePasswordVisibilityClick}
          >
            {isPasswordVisible ? VERIFY_HIDE_PASSWORD : VERIFY_SHOW_PASSWORD}
          </button>
        </div>
        <div className={this.getHintClass()}>{VERIFY_PASSWORD_HINT}</div>

        <button
          type="submit"
          className={this.getSubmitClass()}
          disabled={!isPasswordValid || isSubmitSpinnerVisible}
        >
          <div className="v_button_content">
            {SAVE}
            <div className="v_button_loader">
              <FallingLines
                color="#ffffff"
                width="30"
                visible={isSubmitSpinnerVisible}
              />
            </div>
          </div>
        </button>
        <div className="v_error rr_text_14">{errorMessage}</div>
      </form>
    );
  };

  renderResult = (isSuccess) => (
    <div className="v_card v_card_center">
      {isSuccess && <Success className="mb_20" />}
      <div className="bm_text_24 mb_12">
        {isSuccess ? RESET_PASSWORD_SUCCESS : RESET_PASSWORD_ERROR_TITLE}
      </div>
      <div className="gr_text_16 v_text mb_30">
        {isSuccess ? RESET_PASSWORD_SUCCESS_TEXT : RESET_PASSWORD_ERROR_TEXT}
      </div>
      <button
        type="button"
        className="v_button wm_text_16 blue_button mb_12"
        onClick={this.handleLoginClick}
      >
        {ENTER}
      </button>
      <Link className="v_button v_button_frame dbm_text_16" to="/">
        {TO_MAIN_PAGE}
      </Link>
    </div>
  );

  render() {
    const { stage } = this.state;

    return (
      <div className="content">
        <div className="v_intro" />
        <div className="container v_container">
          {stage === FORM_STAGE
            ? this.renderForm()
            : this.renderResult(stage === SUCCESS_STAGE)}
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  changeLoginModalVisibility: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { changeLoginModalVisibility })(
  ResetPassword,
);
